import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import { Header } from "../../components/new/header/header";
import { translate } from "../../i18n";
import { Homepage } from "../../screens/new/homepage";
import { HomepageAutopayManage } from "../../screens/new/homepage-autopay-manage";
import { DCashRecoveryInit } from "../../screens/more/dcash-recovery-init";

import { SpecificReservation } from "../../screens/home/specific-reservation";
import { deriveUnitTitle, getPropertyAddressFromPropertyProfile } from "../../utils";
import { colors } from "../../theme/colors";
import { PaymentActionTypes } from "../../enums/payment";
import { ServiceRequestSpecificReservation } from "../../screens/service-request/service-request-specific-reservation";
import { CreateServiceRequest } from "../../screens/service-request/create-service-request";
import { ServiceRequestSummary } from "../../screens/service-request/service-request-summary";

const { PAYMENT_STARTED, PAYMENT_IN_REVIEW, PAYMENT_CREATED } = PaymentActionTypes;

const getUnitTitle = (route: any) => {
  const propertyUnit = route?.params?.propertyUnit;
  return deriveUnitTitle(propertyUnit);
};

const getPropertyName = (route: any) => {
  const propName = route?.params?.currentProperty?.name;
  return propName;
};

const getBalanceDue = (route: any) => {
  const balanceDue = route?.params?.balanceDue;
  return balanceDue;
};
const Stack = createStackNavigator();

export const HomeStack = (appMode) => {
  if (appMode == "DCASH_RECOVERY") {
    return HomeDCashRecoveryStack;
  }
  return HomeSummaryStack;
};

/* -------------------------------------- */

export const HomeSummaryStack = () => {
  return (
    <Stack.Navigator
      screenOptions={{ headerMode: "screen", showFullMenu: true }}
      initialRouteName={"Home"}>
      <Stack.Screen
        name="Home"
        component={Homepage}
        options={({ route }) => ({
          header: (props) => <Header {...props} />,
          title: translate("homeStack.myUnits") as string,
          omitBackButton: true,
          omitRightContent: true,
          useLight: false,
          omitTitleHeader: true,
        })}
      />
      <Stack.Screen
        name="HomepageAutopayManage"
        component={HomepageAutopayManage}
        options={({ route }) => ({
          header: (props) => <Header {...props} />,
          title: translate("homepage.autoPayManage.title") as string,
        })}
      />
      <Stack.Screen
        name="SpecificReservation"
        component={SpecificReservation}
        options={({ route }: any) => ({
          header: (props) => <Header {...props} />,
          cardStyle: { backgroundColor: colors.background },
          title: getUnitTitle(route),
          balanceDue: getBalanceDue(route),
          showBalance: true,
          showProperty: false,
          omitRightContent: true,
        })}
      />
      <Stack.Screen
        name="MaintenanceRequests"
        component={ServiceRequestSpecificReservation}
        options={({ route }: any) => ({
          header: (props) => <Header {...props} />,
          title: getUnitTitle(route),
          omitRightContent: true,
        })}
      />
      <Stack.Screen
        name="SubmitServiceRequest"
        component={CreateServiceRequest}
        options={({ route }) => ({
          header: (props) => <Header {...props} />,
          headerMode: "screen",
          title: translate("serviceStack.requestService"),
          omitRightContent: true,
        })}
      />
      <Stack.Screen
        name="ServiceRequestSummaryScreen"
        component={ServiceRequestSummary}
        options={({ route }) => ({
          header: (props) => <Header {...props} />,
          title: translate("serviceStack.requestService") as string,
          useLight: true,
          omitBackButton: true,
          omitRightContent: true,
        })}
      />
    </Stack.Navigator>
  );
};

export const HomeDCashRecoveryStack = () => {
  return (
    <Stack.Navigator
      screenOptions={{ headerMode: "screen", showFullMenu: false }}
      initialRouteName="CertifiedLearnMore">
      <Stack.Screen
        name="DCashRecoveryInit"
        component={DCashRecoveryInit}
        options={({ route }) => ({
          header: (props) => <Header {...props} />,
          title: translate("dcashRecoveryInit.title"),
          omitBackButton: true,
          omitRightContent: true,
          useLight: false,
        })}
      />
    </Stack.Navigator>
  );
};
